import { render } from "./yesterdayPush.vue?vue&type=template&id=4e2122de&scoped=true"
import script from "./yesterdayPush.vue?vue&type=script&lang=js"
export * from "./yesterdayPush.vue?vue&type=script&lang=js"

import "./yesterdayPush.vue?vue&type=style&index=0&id=4e2122de&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2122de"]])

export default __exports__